import { render, staticRenderFns } from "./PasswordValidator.vue?vue&type=template&id=9638bffc&scoped=true&"
import script from "./PasswordValidator.vue?vue&type=script&lang=js&"
export * from "./PasswordValidator.vue?vue&type=script&lang=js&"
import style0 from "./PasswordValidator.vue?vue&type=style&index=0&id=9638bffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9638bffc",
  null
  
)

export default component.exports